var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.bypassFormVisible
    ? _c(
        "div",
        {
          staticClass: "bypass-reason",
          attrs: { bypassFormVisible: _vm.bypassFormVisible },
          on: {
            "update:bypassFormVisible": function ($event) {
              _vm.bypassFormVisible = $event
            },
            "update:bypass-form-visible": function ($event) {
              _vm.bypassFormVisible = $event
            },
          },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  staticClass: "bypass-reason-select",
                  attrs: {
                    placeholder: "Select reason",
                    "popper-class": "select-replacement-reason-dropdown",
                  },
                  on: { change: _vm.sendBypassReason },
                  model: {
                    value: _vm.selectedBypassReason,
                    callback: function ($$v) {
                      _vm.selectedBypassReason = $$v
                    },
                    expression: "selectedBypassReason",
                  },
                },
                _vm._l(_vm.bypassReasons, function (reason) {
                  return _c(
                    "el-option",
                    {
                      key: reason,
                      staticClass: "select-replacement-reason-option",
                      attrs: { label: reason, value: reason },
                    },
                    [
                      _c("span", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(reason)),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { width: "45%", "padding-bottom": "32px" } },
      [
        _c("div", { staticClass: "warning-img" }, [
          _c("img", {
            staticStyle: {
              height: "48px",
              width: "48px",
              "margin-bottom": "8px",
            },
            attrs: { src: require("../../../assets/warning-icon.svg") },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "heading" }, [
          _vm._v("\n      Select the bypass reason.\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "word-break": "break-word" } }, [
          _c("div", [
            _vm._v(
              "\n        Please select the reason for warranty requirement bypass.\n      "
            ),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }